import { NgModule } from '@angular/core';
import {
    MatButtonModule,
    MatToolbarModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    MatCardModule,
    MatSidenavModule,
    MatListModule,
    MatIconModule,
    MatMenuModule,
    MatGridListModule,
    MatSnackBarModule,
    MatExpansionModule,
    MatOptionModule,
    MatSelectModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatCheckboxModule,
    MatDialogModule,
    MatTabsModule,
    MatSortModule,
    MatTableModule,
    MatTooltipModule,
    MatPaginatorModule
} from '@angular/material';

@NgModule({
    imports: [MatButtonModule,
        MatToolbarModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatCardModule,
        MatSidenavModule,
        MatListModule,
        MatSnackBarModule,
        MatIconModule,
        MatMenuModule,
        MatGridListModule,
        MatExpansionModule,
        MatOptionModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatDialogModule,
        MatTabsModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        MatPaginatorModule],
    exports: [MatButtonModule,
        MatToolbarModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatProgressBarModule,
        MatCardModule,
        MatSidenavModule,
        MatListModule,
        MatSnackBarModule,
        MatIconModule,
        MatMenuModule,
        MatGridListModule,
        MatExpansionModule,
        MatOptionModule,
        MatSelectModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatCheckboxModule,
        MatDialogModule,
        MatTabsModule,
        MatSortModule,
        MatTableModule,
        MatTooltipModule,
        MatPaginatorModule]
})
export class MaterialModule { }